import * as React from 'react'
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
} from '@design/pt-ui'
import { AdminFilterHook } from './Filter'
import { translateWithUserLocale } from '../../utils/i18n'
import { Project } from '../../interfaces/entities/project'

interface Column {
  id: 'name' | 'status'
  label: string
  minWidth?: number
  align?: 'left'
  format?: (value: number) => string
}
const columns: Column[] = [
  { id: 'name', label: 'Name', minWidth: 170 },
  { id: 'status', label: 'Status', minWidth: 170 },
]

type Props = {
  adminFilter: AdminFilterHook
}

export default function UserTable(props: Props) {
  const [page, setPage] = React.useState(0)
  const [rowsPerPage, setRowsPerPage] = React.useState(10)

  const selectedUser = props.adminFilter.state.selectedUser

  const projects =
    selectedUser === null || !selectedUser.restrictedAccess
      ? []
      : (props.adminFilter.state.projectsForUser || []).sort(
          (p1: Project, p2: Project) => {
            if (p1.name.toLowerCase() > p2.name.toLowerCase()) {
              return 1
            }
            if (p1.name.toLowerCase() < p2.name.toLowerCase()) {
              return -1
            }
            return 0
          },
        )

  const handleChangePage = (_event: unknown, newPage: number) => {
    setPage(newPage)
  }
  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    setRowsPerPage(+event.target.value)
    setPage(0)
  }
  if (projects === null) {
    return null
  }
  return (
    <div style={{ width: '100%' }}>
      <h2
        style={{
          paddingBottom: 0,
          marginBottom: 25,
          paddingTop: 0,
          marginTop: 25,
        }}>
        {translateWithUserLocale('user.management_user_access_table')}
      </h2>

      <Paper sx={{ width: '100%', mb: 2 }}>
        <TableContainer>
          <Table stickyHeader aria-label="sticky table" sx={{ minWidth: 250 }}>
            <TableHead>
              <TableRow>
                {columns.map((column) => (
                  <TableCell
                    key={column.id}
                    align={column.align}
                    sx={{ minWidth: column.minWidth }}>
                    {column.label}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {projects.map((project) => {
                return (
                  <TableRow
                    hover
                    role="checkbox"
                    tabIndex={-1}
                    key={project.id}>
                    {columns.map((column) => {
                      let value = project[column.id]
                      if (column.id === 'status') {
                        value = project.status.title
                      }
                      return (
                        <TableCell key={column.id} align={column.align}>
                          {column.format && typeof value === 'number'
                            ? column.format(value)
                            : String(value)}
                        </TableCell>
                      )
                    })}
                  </TableRow>
                )
              })}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[10, 25, 100]}
          component="div"
          count={projects.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Paper>
    </div>
  )
}
